import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { BlockFactory } from "../../../blockly/BlockFactory";
import { useRoute, useRouter } from "vue-router";
import { backToBlocklyPage } from "../functional/backToBlocklyPage";
import { block_translation } from "../../../lang/BlockTranslation";
interface Prop {
  type: string;
  assetPath: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VrmAnimButton',
  props: {
    type: null,
    assetPath: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
  assetPath: string;
};

const t = block_translation;

const route = useRoute();
const router = useRouter();
const title = t.to("VRMアニメーション", "vrm_anim");
const addVrmAnimElement = (): void => {
  const factory = new BlockFactory();
  const video = factory.getVRMAnimation(props.assetPath);
  factory.addWorkspaceAfterMounted(video);

  MessageDialog.info(`VRMアニメーションブロックを追加しました`);
  backToBlocklyPage(route, router);

};
const buttonName = t.to("VRMアニメーション属性","to_vrm_anim")

return (_ctx: any,_cache: any) => {
  return (props.type === 'vrm_anim')
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-outline-dark",
        onClick: addVrmAnimElement
      }, _toDisplayString(_unref(buttonName)), 1))
    : _createCommentVNode("", true)
}
}

})